// React
import React from "react";

// Material UI
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

// Helper Functions
import { formatDate } from "../../../../../Helpers/formatters";

const LoginLogsBody = ({ loginLogs }) => {
  return (
    <TableBody>
      {loginLogs.map(({accessDate, ipAddress}, index) => {
        return (
          <TableRow key={index}>
            <TableCell className="tableCell" align="center">
              {formatDate(accessDate)}
            </TableCell>
            <TableCell className="tableCell" align="center">
              {ipAddress}
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  );
};

export default LoginLogsBody;
